import { render, staticRenderFns } from "./AlertsItem.vue?vue&type=template&id=1c0c23fb&"
import script from "./AlertsItem.vue?vue&type=script&lang=js&"
export * from "./AlertsItem.vue?vue&type=script&lang=js&"
import style0 from "./AlertsItem.vue?vue&type=style&index=0&id=1c0c23fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports